
import React, { useRef, useState } from 'react';
import './AutoHeightTextarea.css';

const AutoHeightTextarea = ({ placeholder = "Type something...", value, onChange }) => {
  const textareaRef = useRef(null);
  const [text, setText] = useState(value || "");

  const handleInputChange = (e) => {
    const textarea = textareaRef.current;
    setText(e.target.value);
    if (textarea) {
      textarea.style.height = "auto"; // Reset height to auto
      textarea.style.height = `${textarea.scrollHeight}px`; // Adjust height based on scrollHeight
    }
    if (onChange) onChange(e.target.value);
  };

  return (
    <textarea
      ref={textareaRef}
      value={text}
      onChange={handleInputChange}
      placeholder={placeholder}
      className="auto-height-textarea"
    />
  );
};

export default AutoHeightTextarea;
